import React, { useState, useEffect, Fragment } from 'react';
import { Row, Card, CardBody,Button } from 'reactstrap';


import { injectIntl } from 'react-intl';
import { connect } from 'react-redux';

import moment from 'moment';
import { RotateSpinner } from 'react-spinners-kit';
import ShowOrders from '../../discounts/orders/Components/ShowOrders';
import ViewOrders from '../../discounts/orders/Components/ViewOrders';
import Statement from '../../discounts/statements';
import { AxiosAPI, getGroupID } from '../../../../../helpers/AxiosAPI';
import { gAPI_Orders_Voucher } from '../../../../../constants/APIs';
function Index({ propertyId, locale }) {
    const [startDate, setStartDate] = useState(moment().subtract(15, 'days'));
    const [endDate, setEndDate] = useState(moment());
    const [loading, setLoading] = useState(true);
    const [orderList, setOrderList] = useState([]);
    const [subOrderList, setSubOrderList] = useState([]);
    const [orderData, setOrderData] = useState([]);
    const [orderId, setOrderId] = useState();
    const [showOrderData, setShowOrderData] = useState(false);
    const [showOrdeList, setShowOrderList] = useState(false);
     const[showStatement,setShowStatement]=useState(false);
    const [showsubOrdeList, setShowSubOrderList] = useState(true);
    const handleViewOrderClick = (id, data) => {        
        OrderData(id);
        setShowOrderData(true);
        setSubOrderList(data);
    };

    const onstartDateChnage = (date) => {
        setStartDate(date);
    };

    const onEndDateChnage = (date) => {
        setEndDate(date);
    };

    const handleSearchfilter = (search, status) => {        
        LoadSearchOrderData(search.length === 0 ? "" : search, status.trim());
    }

    const handleOrdersVoucherSubmit = () => {
        LoadData(startDate, endDate);
    };

    const LoadData = (startdate, enddate) => {
        setOrderList([]);
        let fromDate = startdate ? startDate.format('YYYY-MM-DD') + ' 00:00:00' : '';
        let toDate = enddate ? endDate.format('YYYY-MM-DD') + ' 23:59:59' : '';
        AxiosAPI({
            method: 'get',
            url: `${gAPI_Orders_Voucher}?fromDate=${fromDate}&toDate=${toDate}&groupId=${getGroupID()}&propertyId=${"All"}`,
        })
            .then(res => {
                setOrderList(res.data);
                setLoading(false);
                setShowOrderList(true);
            
            })
            .catch(err => console.log('err', err));
    }

    const LoadSearchOrderData = (search, status) => {
        setOrderList([]);
        AxiosAPI({
            method: 'get',
            url: `${gAPI_Orders_Voucher}/search?status=${status}&search=${search}&groupId=${getGroupID()}&propertyId=${"All"}`,
        })
            .then(res => {
                setOrderList(res.data);
                setLoading(false);                
            })
            .catch(err => console.log('err', err));
    }

    const OrderData = (id) => {
        setOrderData([]);
        AxiosAPI({
            method: 'get',
            url: `${gAPI_Orders_Voucher}/detail?orderId=${id}`,
        })
            .then(res => {
                setOrderData(res.data.items);                
            })
            .catch(err => console.log('err', err));
    }

    useEffect(() => {
        LoadData(startDate, endDate);
    }, [propertyId]);

    return (
      <Fragment>
        <div className="row mb-3">
          <div className="col-md-6 mb-1">
            <Button
              color="primary"
              outline              
              size="lg"
              onClick={() => {
                setShowStatement(false);
              }}
              style={{ width: '100%', borderRadius: '6px',backgroundColor:`${ showStatement===false ? "#EF4A81 ":""   }` }}
            >
               Order History
            </Button>
          </div>
          <div className="col-md-6 mb-1">
            <Button
              color="primary"
              outline
              size="lg"              
              onClick={() => {
                setShowStatement(true);
              }}
              style={{ width: '100%', borderRadius: '6px',backgroundColor:`${ showStatement===true ? "#EF4A81 ":""   }` }}
            >
              Statement
            </Button>
          </div>
        </div>

        {showStatement !==undefined && showStatement===false && showOrdeList && (
          <ShowOrders
            onstartDateChange={onstartDateChnage}
            onEndDateChange={onEndDateChnage}
            handleSubmit={handleOrdersVoucherSubmit}
            orderList={orderList}
            LoadData={LoadData}
            startDate={startDate}
            endDate={endDate}
            handleViewOrderClick={handleViewOrderClick}
            handleSearchfilter={handleSearchfilter}
          />
        )}
        {showStatement !==undefined && showStatement===false && !showOrdeList && <Row className="mt-4 justify-content-center">
          <RotateSpinner size={60} color="#EF4A81" loading={true} />
        </Row>}
        {showStatement !== undefined && showStatement === true &&
          <Statement propertyId={"All"}></Statement>}
        {showOrderData && (
          <ViewOrders
            isopen={showOrderData}
            toggle={() => {
              setShowOrderData(false);
            }}
            orderData={orderData}
            subOrderList={subOrderList}
          />
        )}
      </Fragment>
    );
}

const mapStateToProps = ({ settings }) => {
    const { propertyId, locale } = settings;
    return {
        propertyId, locale
    };
};

export default injectIntl(connect(mapStateToProps, {})(Index));



